const Checkbox = ({
  checked,
  toggle,
  notEvery = false,
  className = "",
}: $TSMigrationFixMe) => {
  return (
    <div
      className={`checkbox-wrap ${className} ${
        !notEvery && checked ? "checkbox-selected" : ""
      }`}
      onClick={toggle}
      data-testid='checkbox'
    >
      {notEvery && <div className='notevery-box' />}
      {checked && !notEvery && (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          data-testid='svg'
        >
          <path
            d='M13.3334 4L6.00008 11.3333L2.66675 8'
            stroke='white'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
    </div>
  )
}

export default Checkbox
